"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(props) {
        var _this = _super.call(this, props) || this;
        _this.enterKeyEvent = _this.enterKeyEvent.bind(_this);
        _this.changeFocus = _this.changeFocus.bind(_this);
        return _this;
    }
    RadioButton.prototype.changeFocus = function (nextInputId) {
        var nextInputRef = document.getElementById(nextInputId);
        nextInputRef.focus();
    };
    RadioButton.prototype.enterKeyEvent = function (event) {
        if (event.key == "Enter" && this.props.nextInputId) {
            this.changeFocus(this.props.nextInputId);
        }
    };
    RadioButton.prototype.render = function () {
        var _a = this.props, id = _a.id, disabled = _a.disabled, value = _a.value, json_data = _a.json_data, group_name = _a.group_name, onChange = _a.onChange, className = _a.className;
        var checked = value === json_data[group_name];
        return (React.createElement("input", { type: "radio", id: id, disabled: disabled, name: group_name, value: value, checked: checked, className: className, onChange: function (event) {
                onChange(group_name, value);
            }, onKeyDown: this.enterKeyEvent }));
    };
    return RadioButton;
}(react_1.Component));
exports.RadioButton = RadioButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9CdXR0b24uanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1JhZGlvQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQWEvQjtJQUFpQywrQkFBb0I7SUFDakQscUJBQVksS0FBSztRQUFqQixZQUNJLGtCQUFNLEtBQUssQ0FBQyxTQUdmO1FBRkcsS0FBSSxDQUFDLGFBQWEsR0FBRyxLQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTtRQUNsRCxLQUFJLENBQUMsV0FBVyxHQUFHLEtBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLEtBQUksQ0FBQyxDQUFBOztJQUNsRCxDQUFDO0lBRUQsaUNBQVcsR0FBWCxVQUFZLFdBQVc7UUFDbkIsSUFBTSxZQUFZLEdBQUcsUUFBUSxDQUFDLGNBQWMsQ0FBQyxXQUFXLENBQUMsQ0FBQTtRQUN6RCxZQUFZLENBQUMsS0FBSyxFQUFFLENBQUE7SUFDeEIsQ0FBQztJQUVELG1DQUFhLEdBQWIsVUFBYyxLQUFLO1FBQ2YsSUFBSSxLQUFLLENBQUMsR0FBRyxJQUFJLE9BQU8sSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVcsRUFBRTtZQUNoRCxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUE7U0FDM0M7SUFDTCxDQUFDO0lBRU0sNEJBQU0sR0FBYjtRQUNVLElBQUEsZUFBOEUsRUFBN0UsVUFBRSxFQUFFLHNCQUFRLEVBQUUsZ0JBQUssRUFBRSx3QkFBUyxFQUFFLDBCQUFVLEVBQUUsc0JBQVEsRUFBRSx3QkFBdUIsQ0FBQTtRQUNwRixJQUFNLE9BQU8sR0FBRyxLQUFLLEtBQUssU0FBUyxDQUFDLFVBQVUsQ0FBQyxDQUFBO1FBRS9DLE9BQU8sQ0FDSCwrQkFDSSxJQUFJLEVBQUMsT0FBTyxFQUNaLEVBQUUsRUFBRSxFQUFFLEVBQ04sUUFBUSxFQUFFLFFBQVEsRUFDbEIsSUFBSSxFQUFFLFVBQVUsRUFDaEIsS0FBSyxFQUFFLEtBQUssRUFDWixPQUFPLEVBQUUsT0FBTyxFQUNoQixTQUFTLEVBQUUsU0FBUyxFQUNwQixRQUFRLEVBQUUsVUFBQyxLQUFLO2dCQUNaLFFBQVEsQ0FBQyxVQUFVLEVBQUUsS0FBSyxDQUFDLENBQUE7WUFDL0IsQ0FBQyxFQUNELFNBQVMsRUFBRSxJQUFJLENBQUMsYUFBYSxHQUMvQixDQUNMLENBQUE7SUFDTCxDQUFDO0lBQ0wsa0JBQUM7QUFBRCxDQUFDLEFBdENELENBQWlDLGlCQUFTLEdBc0N6QztBQXRDWSxrQ0FBVyJ9